import { BorderRadiusCorners, BordersStyles } from '@factorialco/deprecated-design-system'

const topBorders: BorderRadiusCorners = {
  topLeft: 'abs008',
  topRight: 'abs008',
}
const bottomBorders: BorderRadiusCorners = {
  bottomLeft: 'abs008',
  bottomRight: 'abs008',
}

export const getBorderRadius = (index: number, length: number): BorderRadiusCorners => {
  if (length === 1) {
    return { all: 'abs008' }
  }

  if (index === 0) {
    return topBorders
  } else if (index === length - 1) {
    return bottomBorders
  }

  return {}
}
export const getBorder = (index: number, length: number): BordersStyles => {
  if (length === 1) {
    return { all: { width: 's1', color: 'grey400', style: 'solid' } }
  }

  if (index === 0) {
    return {
      top: { width: 's1', color: 'grey400', style: 'solid' },
      left: { width: 's1', color: 'grey400', style: 'solid' },
      right: { width: 's1', color: 'grey400', style: 'solid' },
    }
  } else if (index === length - 1) {
    return {
      all: { width: 's1', color: 'grey400', style: 'solid' },
    }
  }

  return {
    top: { width: 's1', color: 'grey400', style: 'solid' },
    left: { width: 's1', color: 'grey400', style: 'solid' },
    right: { width: 's1', color: 'grey400', style: 'solid' },
  }
}
